import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { ChevronRight, ChevronDown } from 'react-feather';
import '../../styles.scss';

const CompanyUsers = ({ objectsToRender, isOpen = true }) => {
  const [openUsersId, setOpenUsersId] = useState([]);
  const { formatMessage } = useIntl();

  const hasChildren = object => object.childs && object.childs.length;

  return (
    <>
      {objectsToRender.map((child, i) => {
        return (
          <div key={child.id} className={`company-user ${isOpen ? 'display-user' : 'hide-user'}`}>
            <div
              className="item"
              style={{ marginLeft: `${hasChildren(child) 
                  ? `${20 * child.level}px` 
                  : `${25 * child.level}px`}` 
                }}
              onClick={() => {
                if (openUsersId.includes(child.id)) {
                  const tmp = [...openUsersId];
                  setOpenUsersId(tmp.filter(id => id !== child.id))
                } else {
                  setOpenUsersId(old => [...old, child.id])
                }
              }}
            >
              {hasChildren(child) && (openUsersId.includes(child.id) ? <ChevronDown size={20} /> : <ChevronRight size={20} />)}
              <strong>{child.nome}</strong>
              <span>{formatMessage({ id: 'consultas-feitas' })}: {child.consultas_feitas}</span>
            </div>
            
            {hasChildren(child) && <CompanyUsers objectsToRender={child.childs} isOpen={openUsersId.includes(child.id)} />}
          </div>
        )
      })}
    </>
  )
}

export default CompanyUsers;